import { VehicleDowntime } from '@deliveries-app/models';
import moment from 'moment';
import { ImCancelCircle } from 'react-icons/im';
interface MaintenanceTableProps {
  vehicleDowntime: VehicleDowntime[];
  onDelete: (a: number) => void;
}
const MaintenanceTable = ({
  vehicleDowntime,
  onDelete,
}: MaintenanceTableProps) => {
  return (
    <table className="w-full table-auto">
      <thead>
        <tr>
          <th>Start Date</th>
          <th>End Date</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {vehicleDowntime &&
          vehicleDowntime.map((val, index) => {
            return (
              <tr key={index}>
                <td>
                  {moment(val.start_time, 'YYYY-MM-DD HH:mm:ss').format(
                    'YYYY-MM-DD HH:mm:ss'
                  )}
                </td>
                <td>
                  {' '}
                  {moment(val.end_time, 'YYYY-MM-DD HH:mm:ss').format(
                    'YYYY-MM-DD HH:mm:ss'
                  )}
                </td>
                <td
                  className="flex cursor-pointer flex-col items-center"
                  onClick={() => onDelete(val.id)}
                >
                  <ImCancelCircle size={20} color="#FF0000" />
                </td>
              </tr>
            );
          })}
        <tr></tr>
      </tbody>
    </table>
  );
};

export default MaintenanceTable;
